import React from "react";
import C from "helpers/HelpConstants";
import Item2ModalEmail from "../Item2ModalEmail";
import { HelpAbility } from "helpers/HelpAbility";

const Table2ModalEmail = ({ vinculedEmails, desvinculedEmail }) => {
    let myAbilities = HelpAbility();

    return (
        <div className="mt-4">
            <div className="row mb-2">
                <div className="col d-flex align-items-end">
                    <h6>Correos Vinculados:</h6>
                </div>
            </div>
            <div className="table-responsive rounded-3" style={{ border: '1px solid black' }}>
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col" className="text-center">Correo</th>
                            <th scope="col" className="text-center">Número de Reportes</th>
                            {myAbilities.hasAny([C.A.CUSTOMER.LINKEMAIL]) &&
                            <th scope="col" className="text-center">Acción</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            vinculedEmails.length
                                ? 
                                vinculedEmails.map((email, i) =>( 
                                    <Item2ModalEmail key={email._id} email={email} i={i} desvinculedEmail={desvinculedEmail} />
                                )) 
                                :
                                <tr>
                                    <td colSpan="5">Sin datos</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
}
export default Table2ModalEmail;
